
export function Services() {
  const services = [
    {
      title: 'Traumatic Brain Injury (TBI)',
      description: 'Comprehensive evaluation, diagnosis, and management of mild, moderate, and severe traumatic brain injuries, including concussions and post-concussive syndrome.',
      icon: 'ri-brain-line',
      features: ['Concussion Assessment', 'Post-Concussive Care', 'Cognitive Evaluation', 'Recovery Planning']
    },
    {
      title: 'Interventional Pain Management',
      description: 'Comprehensive management of complex pain conditions addressing symptoms involving the back, neck, shoulders, arms, knees, and other orthopedic joints.',
      icon: 'ri-pulse-line',
      features: ['Epidural Injections', 'Nerve Blocks', 'Joint Injections', 'Spinal Procedures']
    },
    {
      title: 'Neurodiagnostic Evaluation',
      description: 'Advanced neurodiagnostic assessment using state-of-the-art technology for accurate diagnosis and treatment planning.',
      icon: 'ri-stethoscope-line',
      features: ['EMG Testing', 'Nerve Conduction Studies', 'Diagnostic Imaging', 'Functional Assessment']
    },
    {
      title: 'Medical-Legal Evaluation',
      description: 'Objective, defensible medical-legal evaluations for personal injury, complex trauma, and litigation-related cases with comprehensive reporting.',
      icon: 'ri-file-text-line',
      features: ['QME Services', 'IME Evaluations', 'Expert Testimony', 'Causation Analysis']
    },
    {
      title: 'Complex Injury Management',
      description: 'Coordinated care for complex neurological and musculoskeletal injuries with multidisciplinary treatment approaches.',
      icon: 'ri-heart-pulse-line',
      features: ['Injury Assessment', 'Treatment Coordination', 'Rehabilitation Planning', 'Outcome Monitoring']
    },
    {
      title: 'Neurology Services',
      description: 'Expert neurological care for a wide range of conditions including headaches, neuropathy, and neurological disorders.',
      icon: 'ri-mental-health-line',
      features: ['Headache Treatment', 'Neuropathy Care', 'Neurological Disorders', 'Diagnostic Testing']
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <p className="text-emerald-600 font-semibold text-xs sm:text-sm tracking-wide uppercase text-center mb-3 sm:mb-4">
          Our Specialties
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 text-center mb-3 sm:mb-4">
          Specialized Services
        </h2>
        <p className="text-base sm:text-lg text-slate-600 text-center mb-12 sm:mb-16 max-w-3xl mx-auto px-4">
          Dr. Yousefi provides expert care across multiple specialties, combining advanced diagnostics with evidence-based treatment approaches
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-lg p-6 sm:p-8 hover:bg-slate-100 transition-all duration-300 border border-slate-200 hover:border-emerald-500/30 group hover:shadow-lg"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center mb-5 sm:mb-6 bg-emerald-500/10 rounded-full group-hover:bg-emerald-500/20 transition-colors">
                <i className={`${service.icon} text-2xl sm:text-3xl text-emerald-600`}></i>
              </div>
              
              <h3 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2 sm:mb-3">
                {service.title}
              </h3>
              
              <p className="text-xs sm:text-sm text-slate-600 mb-4 sm:mb-5 leading-relaxed">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-xs sm:text-sm text-slate-700">
                    <i className="ri-check-line text-emerald-600 mr-2 flex-shrink-0"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
